import { styled } from '@mui/material';
import { ICON_SIZES } from '../../../../../constants/sizes';
import { colorPalettes } from '../../../../../context/theme';

export const StyledProviderLogo = styled.div`
    background-color: ${({ theme }) =>
      colorPalettes[theme.palette.mode].components.accountSettings.avatar
        .backgroundElement};
    border-radius: 50%;
    width: ${ICON_SIZES['medium']};
    height: ${ICON_SIZES['medium']};
    position: absolute;
    right: 0;
    bottom: 0;

    .avatar-provider-logo-img {
        width: ${ICON_SIZES['medium']};
        position: relative;
        right: 1px;
        cursor: default;
    }
  }
`;
